import React from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import Question from "../../components/Question";
import MoveButton from "../../components/MoveButton";
import { Stack, Box, useTheme, useMediaQuery } from "@mui/material";
import { setOnPrescribedMedication as updateOnPrescribedMedication } from '../../redux/userSlice';
import setPageAndDeferNavigate from "../../lib/setPageAndDeferNavigate";

export default function PrescribedMedication() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
    const user = useSelector((state) => state.user);

    const options = {
        "Yes": "yes",
        "No": "no",
    };

    const handleClick = (option) => {
        dispatch(updateOnPrescribedMedication(options[option]));
        if (options[option] === "yes") {
            setPageAndDeferNavigate(dispatch, '/working-well', navigate);
        } else {
            setPageAndDeferNavigate(dispatch, '/stop-medication-reason', navigate);
        }
    };

    const handleBack = () => {
        setPageAndDeferNavigate(dispatch, '/picked-medication', navigate);
    };

    return (
        <Question
            onBack={handleBack}
            returning={true}
            title="Are you currently on the prescribed medication?"
            subtitle="Select One"
            input={
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    width="100%"
                >
                    <Stack
                        spacing={2}
                        width="100%"
                        maxWidth="sm"
                        alignItems="center"
                    >
                        {Object.keys(options).map((option) => (
                            <MoveButton
                                sx={{
                                    width: isDesktop ? '100%' : '100%',
                                    maxWidth: '400px',
                                }}
                                key={option}
                                onClick={() => handleClick(option)}
                                title={option}
                                selected={user.onPrescribedMedication === options[option]}
                            />
                        ))}
                    </Stack>
                </Box>
            }
        />
    );
}
